import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import BaseComponent from 'pages/BaseComponent';
const LoginPage = React.lazy(() => import(/*webpackChunkName: 'LoginPage' */  'pages/login/LoginPage'));
const HomePage = React.lazy(() => import(/*webpackChunkName: 'HomePage' */  'pages/home/HomePage'));
const PaternityStudyList = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyList' */  'pages/studies/paternity/PaternityStudyList'));
const PaternityStudyAdd = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyAdd' */  'pages/studies/paternity/PaternityStudyAdd'));
const PaternityStudyDetails = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyDetails' */  'pages/studies/paternity/PaternityStudyDetails'));
const PaternityStudyImportGenemapper = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyImportGenemapper' */  'pages/studies/paternity/PaternityStudyImportGenemapper'));
const WitnessList = React.lazy(() => import(/*webpackChunkName: 'WitnessList' */  'pages/witness/WitnessList'));
const WitnessDetails = React.lazy(() => import(/*webpackChunkName: 'WitnessDetails' */  'pages/witness/WitnessDetails'));
const WitnessAdd = React.lazy(() => import(/*webpackChunkName: 'WitnessAdd' */  'pages/witness/WitnessAdd'));
const OfficesAdd = React.lazy(() => import(/*webpackChunkName: 'OfficesAdd' */  'pages/offices/OfficesAdd'));
const OfficesDetails = React.lazy(() => import(/*webpackChunkName: 'OfficesDetails' */  'pages/offices/OfficesDetails'));
const OfficesList = React.lazy(() => import(/*webpackChunkName: 'OfficesList' */  'pages/offices/OfficesList'));
const PaternityStudyInbox = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyInbox' */  'pages/studies/paternity/PaternityStudyInbox'));
const PaternityStudyOutbox = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyOutbox' */  'pages/studies/paternity/PaternityStudyOutbox'));
const StagesList = React.lazy(() => import(/*webpackChunkName: 'StagesList' */  'pages/stages/StagesList'));
const StagesAdd = React.lazy(() => import(/*webpackChunkName: 'StagesAdd' */  'pages/stages/StagesAdd'));
const StagesDetails = React.lazy(() => import(/*webpackChunkName: 'StagesDetails' */  'pages/stages/StagesDetails'));
const TechniquesAdd = React.lazy(() => import(/*webpackChunkName: 'TechniquesAdd' */  'pages/techniques/TechniquesAdd'));
const TechniquesDetails = React.lazy(() => import(/*webpackChunkName: 'TechniquesDetails' */  'pages/techniques/TechniquesDetails'));
const TechniquesList = React.lazy(() => import(/*webpackChunkName: 'TechniquesList' */  'pages/techniques/TechniquesList'));
const ClinicalAnalysisTypesAdd = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisTypesAdd' */  'pages/clinical/analysis/types/ClinicalAnalysisTypesAdd'));
const ClinicalAnalysisTypesDetails = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisTypesDetails' */  'pages/clinical/analysis/types/ClinicalAnalysisTypesDetails'));
const ClinicalAnalysisTypesList = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisTypesList' */  'pages/clinical/analysis/types/ClinicalAnalysisTypesList'));
const ClinicalAnalysisList = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisList' */  'pages/clinical/analysis/ClinicalAnalysisList'));
const ConfirmChangeStage = React.lazy(() => import(/*webpackChunkName: 'ConfirmChangeStage' */  'pages/shared/ConfirmChangeStage'));
const ClinicalAnalysisInbox = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisInbox' */  'pages/clinical/analysis/ClinicalAnalysisInbox'));
const ClinicalAnalysisOutbox = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisOutbox' */  'pages/clinical/analysis/ClinicalAnalysisOutbox'));
const ClinicalAnalysisImport = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisImport' */  'pages/clinical/analysis/ClinicalAnalysisImport'));
const ClinicalAnalysisImportResults = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisImportResults' */  'pages/clinical/analysis/ClinicalAnalysisImportResults'));
const ClinicalAnalysisAdd = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisAdd' */  'pages/clinical/analysis/ClinicalAnalysisAdd'));
const ClinicalAnalysisDetails = React.lazy(() => import(/*webpackChunkName: 'ClinicalAnalysisDetails' */  'pages/clinical/analysis/ClinicalAnalysisDetails'));
const IndividualsList = React.lazy(() => import(/*webpackChunkName: 'IndividualsList' */  'pages/individuals/IndividualsList'));
const IndividualsAdd = React.lazy(() => import(/*webpackChunkName: 'IndividualsAdd' */  'pages/individuals/IndividualsAdd'));
const IndividualsDetails = React.lazy(() => import(/*webpackChunkName: 'IndividualsDetails' */  'pages/individuals/IndividualsDetails'));
const UsersList = React.lazy(() => import(/*webpackChunkName: 'UsersList' */  'pages/users/UsersList'));
const UsersAdd = React.lazy(() => import(/*webpackChunkName: 'UsersAdd' */  'pages/users/UsersAdd'));
const UsersDetails = React.lazy(() => import(/*webpackChunkName: 'UsersDetails' */  'pages/users/UsersDetails'));
const RolesList = React.lazy(() => import(/*webpackChunkName: 'RolesList' */  'pages/roles/RolesList'));
const RolesAdd = React.lazy(() => import(/*webpackChunkName: 'RolesAdd' */  'pages/roles/RolesAdd'));
const RolesDetails = React.lazy(() => import(/*webpackChunkName: 'RolesDetails' */  'pages/roles/RolesDetails'));
const ClientsList = React.lazy(() => import(/*webpackChunkName: 'ClientsList' */  'pages/clients/ClientsList'));
const ClientsAdd = React.lazy(() => import(/*webpackChunkName: 'ClientsAdd' */  'pages/clients/ClientsAdd'));
const ClientsDetails = React.lazy(() => import(/*webpackChunkName: 'ClientsDetails' */  'pages/clients/ClientsDetails'));
const LocationsList = React.lazy(() => import(/*webpackChunkName: 'LocationsList' */  'pages/locations/LocationsList'));
const LocationsDetails = React.lazy(() => import(/*webpackChunkName: 'LocationsDetails' */  'pages/locations/LocationsDetails'));
const LocationsAdd = React.lazy(() => import(/*webpackChunkName: 'LocationsAdd' */  'pages/locations/LocationsAdd'));
const GendersList = React.lazy(() => import(/*webpackChunkName: 'GendersList' */  'pages/genders/GendersList'));
const GendersDetails = React.lazy(() => import(/*webpackChunkName: 'GendersDetails' */  'pages/genders/GendersDetails'));
const GendersAdd = React.lazy(() => import(/*webpackChunkName: 'GendersAdd' */  'pages/genders/GendersAdd'));
const AppointmentSectorAdd = React.lazy(() => import(/*webpackChunkName: 'AppointmentSectorAdd' */  'pages/sectors/SectorsAdd'));
const AppointmentSectorList = React.lazy(() => import(/*webpackChunkName: 'AppointmentSectorList' */  'pages/sectors/SectorsList'));
const AppointmentSectorDetails = React.lazy(() => import(/*webpackChunkName: 'AppointmentSectorDetails' */  'pages/sectors/SectorsDetails'));
const CoordinationTypesAdd = React.lazy(() => import(/*webpackChunkName: 'CoordinationTypeAdd' */  'pages/coordination/types/CoordinationTypesAdd'));
const CoordinationTypesList = React.lazy(() => import(/*webpackChunkName: 'CoordinationTypeList' */  'pages/coordination/types/CoordinationTypesList'));
const CoordinationTypesDetails = React.lazy(() => import(/*webpackChunkName: 'CoordinationTypeDetails' */  'pages/coordination/types/CoordinationTypesDetails'));
const SpecialtiesAdd = React.lazy(() => import(/*webpackChunkName: 'SpecialtiesAdd' */  'pages/specialties/SpecialtiesAdd'));
const SpecialtiesList = React.lazy(() => import(/*webpackChunkName: 'SpecialtiesList' */  'pages/specialties/SpecialtiesList'));
const SpecialtiesDetails = React.lazy(() => import(/*webpackChunkName: 'SpecialtiesDetails' */  'pages/specialties/SpecialtiesDetails'));
const DoctorsList = React.lazy(() => import(/*webpackChunkName: 'DoctorsList' */  'pages/doctors/DoctorsList'));
const DoctorsDetails = React.lazy(() => import(/*webpackChunkName: 'DoctorsDetails' */  'pages/doctors/DoctorsDetails'));
const DoctorsAdd = React.lazy(() => import(/*webpackChunkName: 'DoctorsAdd' */  'pages/doctors/DoctorsAdd'));
const CountriesAdd = React.lazy(() => import(/*webpackChunkName: 'CountriesAdd' */  'pages/countries/CountriesAdd'));
const CountriesList = React.lazy(() => import(/*webpackChunkName: 'CountriesList' */  'pages/countries/CountriesList'));
const CountriesDetails = React.lazy(() => import(/*webpackChunkName: 'CountriesDetails' */  'pages/countries/CountriesDetails'));
const KinshipsAdd = React.lazy(() => import(/*webpackChunkName: 'KinshipsAdd' */  'pages/kinships/KinshipsAdd'));
const KinshipsDetails = React.lazy(() => import(/*webpackChunkName: 'KinshipsDetails' */  'pages/kinships/KinshipsDetails'));
const KinshipsList = React.lazy(() => import(/*webpackChunkName: 'KinshipsList' */  'pages/kinships/KinshipsList'));
const MedicalInstitutionsAdd = React.lazy(() => import(/*webpackChunkName: 'MedicalInstitutionsAdd' */  'pages/medical/institutions/MedicalInstitutionsAdd'));
const MedicalInstitutionsDetails = React.lazy(() => import(/*webpackChunkName: 'MedicalInstitutionsDetails' */  'pages/medical/institutions/MedicalInstitutionsDetails'));
const MedicalInstitutionsList = React.lazy(() => import(/*webpackChunkName: 'MedicalInstitutionsList' */  'pages/medical/institutions/MedicalInstitutionsList'));
const NursesAdd = React.lazy(() => import(/*webpackChunkName: 'NursesAdd' */  'pages/nurses/NurseAdd'));
const NursesDetails = React.lazy(() => import(/*webpackChunkName: 'NursesDetails' */  'pages/nurses/NurseDetails'));
const NursesList = React.lazy(() => import(/*webpackChunkName: 'NurseList' */  'pages/nurses/NurseList'));
const ProductsAdd = React.lazy(() => import(/*webpackChunkName: 'ProductsAdd' */  'pages/products/ProductsAdd'));
const ProductsDetails = React.lazy(() => import(/*webpackChunkName: 'ProductsDetails' */  'pages/products/ProductsDetails'));
const ProductsList = React.lazy(() => import(/*webpackChunkName: 'ProductsList' */  'pages/products/ProductsList'));
const PaternityStudyTypesAdd = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyTypesAdd' */  'pages/studies/paternity/types/PaternityStudyTypesAdd'));
const PaternityStudyTypesDetails = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyTypesDetails' */  'pages/studies/paternity/types/PaternityStudyTypesDetails'));
const PaternityStudyTypesList = React.lazy(() => import(/*webpackChunkName: 'PaternityStudyTypesList' */  'pages/studies/paternity/types/PaternityStudyTypesList'));
const EthnicOriginsAdd = React.lazy(() => import(/*webpackChunkName: 'EthnicOriginsAdd' */  'pages/ethnic/origins/EthnicOriginsAdd'));
const EthnicOriginsDetails = React.lazy(() => import(/*webpackChunkName: 'EthnicOriginsDetails' */  'pages/ethnic/origins/EthnicOriginsDetails'));
const EthnicOriginsList = React.lazy(() => import(/*webpackChunkName: 'EthnicOriginsList' */  'pages/ethnic/origins/EthnicOriginsList'));
const SampleTypesDetails = React.lazy(() => import(/*webpackChunkName: 'SampleTypesDetails' */  'pages/samples/types/SampleTypesDetails'));
const SampleTypesList = React.lazy(() => import(/*webpackChunkName: 'SampleTypesList' */  'pages/samples/types/SampleTypesList'));
const SampleTypesAdd = React.lazy(() => import(/*webpackChunkName: 'SampleTypesAdd' */  'pages/samples/types/SampleTypesAdd'));
const DocumentTypesAdd = React.lazy(() => import(/*webpackChunkName: 'DocumentTypesAdd' */  'pages/document/types/DocumentTypesAdd'));
const DocumentTypesDetails = React.lazy(() => import(/*webpackChunkName: 'DocumentTypesDetails' */  'pages/document/types/DocumentTypesDetails'));
const DocumentTypesList = React.lazy(() => import(/*webpackChunkName: 'DocumentTypesList' */  'pages/document/types/DocumentTypesList'));
const MarkersAdd = React.lazy(() => import(/*webpackChunkName: 'MarkersAdd' */  'pages/markers/MarkersAdd'));
const MarkersDetails = React.lazy(() => import(/*webpackChunkName: 'MarkersDetails' */  'pages/markers/MarkersDetails'));
const MarkersList = React.lazy(() => import(/*webpackChunkName: 'MarkersList' */  'pages/markers/MarkersList'));
const TasksList = React.lazy(() => import(/*webpackChunkName: 'TasksList' */  'pages/tasks/TasksList'));
const ProspectsList = React.lazy(() => import(/*webpackChunkName: 'ProspectsList' */  'pages/prospects/ProspectsList'));
const ProspectsAdd = React.lazy(() => import(/*webpackChunkName: 'ProspectsAdd' */  'pages/prospects/ProspectsAdd'));
const ProspectsDetails = React.lazy(() => import(/*webpackChunkName: 'ProspectsDetails' */  'pages/prospects/ProspectsDetails'));
const ProspectsVisits = React.lazy(() => import(/*webpackChunkName: 'ProspectsVisits' */  'pages/prospects/ProspectsVisits'));
const ProspectsImport = React.lazy(() => import(/*webpackChunkName: 'ProspectsImport' */  'pages/prospects/ProspectsImport'));
const MethodsExtractionAdd = React.lazy(() => import(/*webpackChunkName: 'MethodsExtractionAdd' */  'pages/methods/extraction/MethodsExtractionAdd'));
const MethodsExtractionDetails = React.lazy(() => import(/*webpackChunkName: 'MethodsExtractionDetails' */  'pages/methods/extraction/MethodsExtractionDetails'));
const MethodsExtractionList = React.lazy(() => import(/*webpackChunkName: 'MethodsExtractionList' */  'pages/methods/extraction/MethodsExtractionList'));
const SystemParamsList = React.lazy(() => import(/*webpackChunkName: 'SystemParamsList' */  'pages/system/params/SystemParamsList'));
const GeneralScheduler = React.lazy(() => import("pages/scheduler/GeneralScheduler"));
const AgendaAdd = React.lazy(() => import("pages/scheduler/AgendaAdd"));
const AgendaEdit = React.lazy(() => import("pages/scheduler/AgendaEdit"));
const AgendaDetails = React.lazy(() => import("pages/scheduler/AgendaDetails"));
const AgendaAttachments = React.lazy(() => import("pages/scheduler/AgendaAttachments"));

const oLoginRoute = {
	path: '/login',
	exact: true,
	component: LoginPage
}, oNotFoundRoute = {
	path: '*',
	component: LoginPage
};

const aRoutesUser = [
	{
		path: "/",
		exact: true,
		component: HomePage,
	},
	{
		path: "/appointment/sectors",
		component: BaseComponent,
		routes: [
			{ path: "/appointment/sectors/add", component: AppointmentSectorAdd },
			{
				path: "/appointment/sectors/:nId",
				component: AppointmentSectorDetails,
			},
			{ path: "/appointment/sectors", component: AppointmentSectorList },
		],
	},
	{
		path: "/coordination/types",
		component: BaseComponent,
		routes: [
			{ path: "/coordination/types/add", component: CoordinationTypesAdd },
			{ path: "/coordination/types/:nId", component: CoordinationTypesDetails },
			{ path: "/coordination/types", component: CoordinationTypesList },
		],
	},
	{
		path: '/nurses',
		component: BaseComponent,
		routes: [
			{ path: '/nurses/add', component: NursesAdd },
			{ path: '/nurses/:nId', component: NursesDetails },
			{ path: '/nurses', component: NursesList },
		]
	},
	{
		path: "/studies/paternity/types",
		component: BaseComponent,
		routes: [
			{
				path: "/studies/paternity/types/add",
				component: PaternityStudyTypesAdd,
			},
			{
				path: "/studies/paternity/types/:nId",
				component: PaternityStudyTypesDetails,
			},
			{ path: "/studies/paternity/types", component: PaternityStudyTypesList },
		],
	},
	{
		path: "/studies/paternity",
		component: BaseComponent,
		routes: [
			{
				path: "/studies/paternity/import/genemapper",
				exact: true,
				component: PaternityStudyImportGenemapper,
			},
			{
				path: "/studies/paternity/add",
				exact: true,
				component: PaternityStudyAdd,
			},
			{ path: "/studies/paternity/confirm", component: ConfirmChangeStage },
			{ path: "/studies/paternity/inbox", component: PaternityStudyInbox },
			{ path: "/studies/paternity/outbox", component: PaternityStudyOutbox },
			{ path: "/studies/paternity/:nId/:sTab?", component: PaternityStudyDetails },
			{ path: "/studies/paternity", component: PaternityStudyList },
		],
	},
	{
		path: "/witnesses",
		component: BaseComponent,
		routes: [
			{ path: "/witnesses/add", exact: true, component: WitnessAdd },
			{ path: "/witnesses/:nId", component: WitnessDetails },
			{ path: "/witnesses", component: WitnessList },
		],
	},
	{
		path: "/offices",
		component: BaseComponent,
		routes: [
			{ path: "/offices/add", exact: true, component: OfficesAdd },
			{ path: "/offices/:nId", component: OfficesDetails },
			{ path: "/offices", component: OfficesList },
		],
	},
	{
		path: "/stages",
		component: BaseComponent,
		routes: [
			{ path: "/stages/add", exact: true, component: StagesAdd },
			{ path: "/stages/:nId", component: StagesDetails },
			{ path: "/stages", component: StagesList },
		],
	},
	{
		path: "/techniques",
		component: BaseComponent,
		routes: [
			{ path: "/techniques/add", exact: true, component: TechniquesAdd },
			{ path: "/techniques/:nId", component: TechniquesDetails },
			{ path: "/techniques", component: TechniquesList },
		],
	},
	{
		path: "/clinical/analysis/types",
		component: BaseComponent,
		routes: [
			{
				path: "/clinical/analysis/types/add",
				exact: true,
				component: ClinicalAnalysisTypesAdd,
			},
			{
				path: "/clinical/analysis/types/:nId",
				component: ClinicalAnalysisTypesDetails,
			},
			{
				path: "/clinical/analysis/types",
				component: ClinicalAnalysisTypesList,
			},
		],
	},
	{
		path: "/clinical/analysis",
		component: BaseComponent,
		routes: [
			{
				path: "/clinical/analysis/add",
				exact: true,
				component: ClinicalAnalysisAdd,
			},
			{ path: "/clinical/analysis/confirm", component: ConfirmChangeStage },
			{ path: "/clinical/analysis/inbox", component: ClinicalAnalysisInbox },
			{ path: "/clinical/analysis/outbox", component: ClinicalAnalysisOutbox },
			{
				path: "/clinical/analysis/import/results",
				component: ClinicalAnalysisImportResults,
			},
			{ path: "/clinical/analysis/import", component: ClinicalAnalysisImport },
			{ path: "/clinical/analysis/:nId/:sTab?", component: ClinicalAnalysisDetails },
			{ path: "/clinical/analysis", component: ClinicalAnalysisList },
		],
	},
	{
		path: "/individuals",
		component: BaseComponent,
		routes: [
			{ path: "/individuals/add", component: IndividualsAdd },
			{ path: "/individuals/:nId", component: IndividualsDetails },
			{ path: "/individuals", component: IndividualsList },
		],
	},
	{
		path: "/users",
		component: BaseComponent,
		routes: [
			{ path: "/users/add", exact: true, component: UsersAdd },
			{ path: "/users/:nId", component: UsersDetails },
			{ path: "/users", component: UsersList },
		],
	},
	{
		path: "/roles",
		component: BaseComponent,
		routes: [
			{ path: "/roles/add", exact: true, component: RolesAdd },
			{ path: "/roles/:nId", component: RolesDetails },
			{ path: "/roles", component: RolesList },
		],
	},
	{
		path: "/clients",
		component: BaseComponent,
		routes: [
			{ path: "/clients/add", component: ClientsAdd },
			{ path: "/clients/:nId", component: ClientsDetails },
			{ path: "/clients", component: ClientsList },
		],
	},
	{
		path: "/locations",
		component: BaseComponent,
		routes: [
			{ path: "/locations/add", component: LocationsAdd },
			{ path: "/locations/:nId", component: LocationsDetails },
			{ path: "/locations", component: LocationsList },
		],
	},
	{
		path: "/genders",
		component: BaseComponent,
		routes: [
			{ path: "/genders/add", component: GendersAdd },
			{ path: "/genders/:nId", component: GendersDetails },
			{ path: "/genders", component: GendersList },
		],
	},
	{
		path: "/specialties",
		component: BaseComponent,
		routes: [
			{ path: "/specialties/add", component: SpecialtiesAdd },
			{ path: "/specialties/:nId", component: SpecialtiesDetails },
			{ path: "/specialties", component: SpecialtiesList },
		],
	},
	{
		path: "/doctors",
		component: BaseComponent,
		routes: [
			{ path: "/doctors/add", component: DoctorsAdd },
			{ path: "/doctors/:nId", component: DoctorsDetails },
			{ path: "/doctors", component: DoctorsList },
		],
	},
	{
		path: "/countries",
		component: BaseComponent,
		routes: [
			{ path: "/countries/add", component: CountriesAdd },
			{ path: "/countries/:nId", component: CountriesDetails },
			{ path: "/countries", component: CountriesList },
		],
	},
	{
		path: "/kinships",
		component: BaseComponent,
		routes: [
			{ path: "/kinships/add", component: KinshipsAdd },
			{ path: "/kinships/:nId", component: KinshipsDetails },
			{ path: "/kinships", component: KinshipsList },
		],
	},
	{
		path: "/medical/institutions",
		component: BaseComponent,
		routes: [
			{ path: "/medical/institutions/add", component: MedicalInstitutionsAdd },
			{
				path: "/medical/institutions/:nId",
				component: MedicalInstitutionsDetails,
			},
			{ path: "/medical/institutions", component: MedicalInstitutionsList },
		],
	},
	{
		path: "/products",
		component: BaseComponent,
		routes: [
			{ path: "/products/add", component: ProductsAdd },
			{ path: "/products/:nId", component: ProductsDetails },
			{ path: "/products", component: ProductsList },
		],
	},
	{
		path: "/ethnic/origins",
		component: BaseComponent,
		routes: [
			{ path: "/ethnic/origins/add", component: EthnicOriginsAdd },
			{ path: "/ethnic/origins/:nId", component: EthnicOriginsDetails },
			{ path: "/ethnic/origins", component: EthnicOriginsList },
		],
	},
	{
		path: "/sample/types",
		component: BaseComponent,
		routes: [
			{ path: "/sample/types/add", component: SampleTypesAdd },
			{ path: "/sample/types/:nId", component: SampleTypesDetails },
			{ path: "/sample/types", component: SampleTypesList },
		],
	},
	{
		path: "/document/types",
		component: BaseComponent,
		routes: [
			{ path: "/document/types/add", component: DocumentTypesAdd },
			{ path: "/document/types/:nId", component: DocumentTypesDetails },
			{ path: "/document/types", component: DocumentTypesList },
		],
	},
	{
		path: "/markers",
		component: BaseComponent,
		routes: [
			{ path: "/markers/add", component: MarkersAdd },
			{ path: "/markers/:nId", component: MarkersDetails },
			{ path: "/markers", component: MarkersList },
		],
	},
	{
		path: "/tasks",
		component: BaseComponent,
		routes: [{ path: "/tasks", component: TasksList }],
	},
	{
		path: "/prospects",
		component: BaseComponent,
		routes: [
			{ path: "/prospects/add", component: ProspectsAdd },
			{ path: "/prospects/visits", component: ProspectsVisits },
			{ path: "/prospects/confirm", component: ConfirmChangeStage },
			{ path: "/prospects/import", component: ProspectsImport },
			{ path: "/prospects/:nId", component: ProspectsDetails },
			{ path: "/prospects", component: ProspectsList },
		],
	},
	{
		path: "/extraction/methods",
		component: BaseComponent,
		routes: [
			{ path: "/extraction/methods/add", component: MethodsExtractionAdd },
			{ path: "/extraction/methods/:nId", component: MethodsExtractionDetails },
			{ path: "/extraction/methods", component: MethodsExtractionList },
		],
	},
	{
		path: "/system/params",
		component: BaseComponent,
		routes: [{ path: "/system/params", component: SystemParamsList }],
	},
	{
		path: "/calendar",
		component: BaseComponent,
		routes: [
			{ path: "/calendar/add/:date", component: AgendaAdd },
			{ path: "/calendar/edit/:id", component: AgendaEdit },
			{ path: "/calendar/attachments/:id", component: AgendaAttachments },
			{ path: "/calendar/:id", component: AgendaDetails },
			{ path: "/calendar", component: GeneralScheduler },
		]
	},
];

function RouteConfig(props) {
	let aRoutes = [oLoginRoute];
	aRoutes = aRoutes.concat(aRoutesUser);
	aRoutes.push(oNotFoundRoute);
	return (
		<Switch>
			{aRoutes.map((oRouter, nIndex) => (
				<RouteWithSubRoutes key={nIndex} {...oRouter} />
			))}
		</Switch>
	);
}

// A special wrapper for <Route> that knows how to
// handle 'sub'-routes by passing them in a `routes`
// prop to the component it renders.
export function RouteWithSubRoutes(route) {
	return (
		<Route
			path={route.path}
			render={props => (
				// pass the sub-routes down to keep nesting
				<route.component {...props} routes={route.routes} />
			)}
		/>
	);
}

const mapStateToProps = oState => ({
	oSession: oState.SessionReducer
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RouteConfig);